import { render } from "./DetailActivites.vue?vue&type=template&id=3d29bca4&scoped=true"
import script from "./DetailActivites.vue?vue&type=script&lang=js"
export * from "./DetailActivites.vue?vue&type=script&lang=js"

import "./DetailActivites.vue?vue&type=style&index=0&id=3d29bca4&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d29bca4"]])

export default __exports__